// Romania travel journal posts. Imagery illustrates each real Romanian location.
export interface RomaniaBlogPost {
  id: number;
  title: string;
  excerpt: string;
  image: string;
  location: string;
  category: string;
  author: string;
  date: string;
  featured?: boolean;
}

export const blogPostsRomania: RomaniaBlogPost[] = [
  {
    id: 1,
    title: 'Transylvania: Inside the Real Land of Dracula',
    excerpt: 'Beyond the legend lies a region of medieval Saxon citadels, fortified churches, and rolling green hills. Discover why Transylvania is one of Europe\u2019s most enchanting destinations.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406694217_33fd396b.png',
    location: 'Transylvania',
    category: 'Destinations',
    author: 'Andrei Popescu',
    date: 'March 15, 2026',
    featured: true,
  },
  {
    id: 2,
    title: 'Bran Castle: Separating the Dracula Myth from History',
    excerpt: 'Perched on a cliff between Transylvania and Wallachia, Bran Castle is far more than a vampire legend. Here is your complete guide to Romania\u2019s most famous fortress.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407038576_f3a526f0.jpg',
    location: 'Bran',
    category: 'Heritage',
    author: 'Ioana Munteanu',
    date: 'March 8, 2026',
  },
  {
    id: 3,
    title: 'Driving the Transf\u0103g\u0103r\u0103\u0219an: Europe\u2019s Greatest Road',
    excerpt: 'Climbing past glacial B\u00e2lea Lake to over 2,000 metres, the Transf\u0103g\u0103r\u0103\u0219an is one of the world\u2019s most spectacular alpine drives. Everything you need to plan the journey.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406729379_e48b2fcd.jpg',
    location: 'F\u0103g\u0103ra\u0219 Mountains',
    category: 'Adventure',
    author: 'Mihai Ionescu',
    date: 'February 28, 2026',
  },
  {
    id: 4,
    title: 'Romanian Cuisine: A Feast of Sarmale, M\u0103m\u0103lig\u0103 & More',
    excerpt: 'From hearty stuffed cabbage rolls to creamy polenta and smoky grilled m\u0103m\u0103lig\u0103, Romanian food is rich, rural, and deeply comforting. The dishes you must try.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406991780_948d51c0.jpg',
    location: 'Maramure\u0219',
    category: 'Culinary',
    author: 'Elena Dumitru',
    date: 'February 20, 2026',
  },
  {
    id: 5,
    title: 'Sighi\u0219oara: The Medieval Citadel That Time Forgot',
    excerpt: 'A perfectly preserved UNESCO World Heritage town of cobbled lanes, pastel houses, and an iconic Clock Tower. Walk through the birthplace of Vlad the Impaler.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406747350_8457a0d3.jpg',
    location: 'Sighi\u0219oara',
    category: 'Heritage',
    author: 'Andrei Popescu',
    date: 'February 12, 2026',
  },
  {
    id: 6,
    title: 'Pele\u0219 Castle: Romania\u2019s Fairytale Royal Palace',
    excerpt: 'Nestled in the Carpathian forests of Sinaia, this Neo-Renaissance masterpiece dazzles with ornate woodwork and opulent interiors. A complete visitor\u2019s guide.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406711915_8dbdbfed.jpg',
    location: 'Sinaia',
    category: 'Luxury',
    author: 'Ioana Munteanu',
    date: 'February 5, 2026',
  },
  {
    id: 7,
    title: 'The Painted Monasteries of Bucovina',
    excerpt: 'Vivid 15th-century frescoes glowing in the famous Vorone\u021b blue cover these UNESCO-listed monasteries. A pilgrimage through living Byzantine art in northern Romania.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407144146_47a87a8c.png',
    location: 'Bucovina',
    category: 'Heritage',
    author: 'Mihai Ionescu',
    date: 'January 28, 2026',
  },
  {
    id: 8,
    title: 'Danube Delta Safari: Europe\u2019s Wildest Wetland',
    excerpt: 'A labyrinth of channels and reed beds teeming with pelicans and over 300 bird species. How to explore the UNESCO Biosphere Reserve by traditional boat.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757845948_efe1656f.jpeg',
    location: 'Tulcea',
    category: 'Nature',
    author: 'Elena Dumitru',
    date: 'January 20, 2026',
  },
  {
    id: 9,
    title: 'Bra\u0219ov: The Saxon Gem Beneath the Carpathians',
    excerpt: 'A grand medieval square, the towering Black Church, and Mount T\u00e2mpa rising above the rooftops. Why Bra\u0219ov is the perfect base for exploring Transylvania.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406871867_2e77a690.png',
    location: 'Bra\u0219ov',
    category: 'Destinations',
    author: 'Andrei Popescu',
    date: 'March 12, 2026',
  },
  {
    id: 10,
    title: 'Bear Watching in the Carpathian Wilderness',
    excerpt: 'Romania is home to nearly two-thirds of Europe\u2019s brown bears. From hides in Piatra Craiului to guided treks, here is how to responsibly track wildlife.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406931392_5b35878a.jpg',
    location: 'Piatra Craiului',
    category: 'Adventure',
    author: 'Mihai Ionescu',
    date: 'March 5, 2026',
  },
  {
    id: 11,
    title: 'Bucharest: Belle \u00c9poque Grandeur & Buzzing Caf\u00e9 Culture',
    excerpt: 'From the colossal Palace of the Parliament to leafy boulevards once called the \u201cParis of the East,\u201d Romania\u2019s capital is a city of contrasts. Your weekend guide.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757621439_942716a5.jpeg',
    location: 'Bucharest',
    category: 'Destinations',
    author: 'Ioana Munteanu',
    date: 'February 26, 2026',
  },
  {
    id: 12,
    title: 'Sibiu: A Former Capital of Culture With \u201cEyes\u201d',
    excerpt: 'Pastel Saxon fa\u00e7ades, cobbled squares, and the famous \u201ceyes of Sibiu\u201d rooftops. Discover one of Transylvania\u2019s most charming and creative cities.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406947493_df28616a.jpg',
    location: 'Sibiu',
    category: 'Heritage',
    author: 'Andrei Popescu',
    date: 'February 22, 2026',
  },
  {
    id: 13,
    title: 'Big\u0103r Waterfall & the Nera Gorges of Banat',
    excerpt: 'A fairytale moss-draped waterfall and emerald gorges hidden deep in the Anina Mountains, where turquoise rivers carve through wild limestone canyons.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406901686_8dd8183f.jpg',
    location: 'Cara\u0219-Severin',
    category: 'Nature',
    author: 'Mihai Ionescu',
    date: 'February 18, 2026',
  },
  {
    id: 14,
    title: 'Romanian Wine: Cotnari, Murfatlar & Indigenous Grapes',
    excerpt: 'From the legendary sweet whites of Cotnari to bold reds along the Black Sea, Romania has one of Europe\u2019s oldest wine cultures. The vineyards worth visiting.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407013829_a9ba8309.png',
    location: 'Cotnari',
    category: 'Culinary',
    author: 'Elena Dumitru',
    date: 'February 14, 2026',
  },
  {
    id: 15,
    title: 'The Black Sea Coast: Constan\u021ba, Mamaia & Roman Mosaics',
    excerpt: 'Golden sandy beaches, lively seaside resorts, and the ancient port of Constan\u021ba where Roman heritage meets sun-soaked promenades. A summer guide.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406964465_4a7ff604.jpg',
    location: 'Constan\u021ba',
    category: 'Destinations',
    author: 'Ioana Munteanu',
    date: 'February 8, 2026',
  },
  {
    id: 16,
    title: 'Saxon Villages: Fortified Churches & Boutique Stays',
    excerpt: 'Stay in lovingly restored Saxon manor houses across Transylvania, from Viscri\u2019s fortified church to quiet countryside life blended with contemporary luxury.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407057205_9a1931d0.png',
    location: 'Viscri',
    category: 'Luxury',
    author: 'Andrei Popescu',
    date: 'February 2, 2026',
  },
  {
    id: 17,
    title: 'Best Time to Visit Romania: A Season-by-Season Guide',
    excerpt: 'From spring wildflowers in the Carpathians to golden autumn vineyards and snowy castle escapes, here is exactly when to plan your Romanian journey.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406729379_e48b2fcd.jpg',
    location: 'Carpathians',
    category: 'Destinations',
    author: 'Mihai Ionescu',
    date: 'January 24, 2026',
  },
  {
    id: 18,
    title: 'Maramure\u0219: Wooden Churches & Living Traditions',
    excerpt: 'In Romania\u2019s far north, tall wooden churches, hand-carved gates, and centuries-old village customs survive untouched. A journey into rural Romania\u2019s soul.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407144146_47a87a8c.png',
    location: 'Maramure\u0219',
    category: 'Heritage',
    author: 'Elena Dumitru',
    date: 'January 17, 2026',
  },
];

export const romaniaBlogCategories = ['All', 'Destinations', 'Heritage', 'Adventure', 'Culinary', 'Luxury', 'Nature'];
